<onyx-dropdown
  [formControl]="control()"
  label="labels.roles"
  [options]="options()"
  [multiple]="true"
  [showSelectAll]="false"
></onyx-dropdown>
